import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';
import { GET_CATEGORY, GET_CATEGORY_SUCCESS, GET_CATEGORY_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getCategory({ payload }) {
  // let URL = `${uaeProjectsBaseURL}/admin/categories`

  // let urlParams = ''
  // if (payload?.pagination) {
  //   urlParams = `${`pageIndex=${payload?.urlParam?.pageIndex}`}&${`pageSize=${Constant?.TABLE_PAGE_SIZE}`}`
  // } else {
  //   if (payload?.urlParam?.categoryId) {
  //     URL = `categoryId=${payload?.urlParam?.categoryId}`
  //   }
  // }

  try {
    // const response = yield call(apiCall, {
    //   url: `${URL}${`${urlParams === '' ? '' : `?${urlParams}`}`}`,
    //   method: 'GET',
    //   headers: {
    //     Authorization: Constant?.CLIENT_TOKEN,
    //     ...customHeaders,
    //   },
    // })

    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/categories`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CATEGORY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CATEGORY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CATEGORY_ERROR, payload: error });
  }
}

export function* watchGetCategory() {
  yield takeEvery(GET_CATEGORY, getCategory);
}

function* getCategorySaga() {
  yield all([fork(watchGetCategory)]);
}

export default getCategorySaga;
